import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import ContentWrapper from '../components/contentwrapper/ContentWrapper'
import { Link } from 'react-router-dom'
import { AiFillEdit, AiOutlinePlus } from 'react-icons/ai'
import { activeStatus, fetchAllDataAPI, removeDataFromList } from '../utils/api'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'
import { VscTrash } from "react-icons/vsc";
import moment from 'moment'
import { Table } from 'react-bootstrap'
import Skeleton from 'react-loading-skeleton'

const Holiday = () => {
    const [holiday, setHoliday] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const recordPerPage = 10;
    const lastIndex = currentPage * recordPerPage;
    const firstIndex = lastIndex - recordPerPage;
    const records = holiday.slice(firstIndex, lastIndex);
    const npage = Math.ceil(holiday.length / recordPerPage)
    const numbers = [...Array(npage + 1).keys()].slice(1)

    useEffect(() => {
        getHoliday();
    }, []);

    const getHoliday = () => {
        setIsLoading(true);
        fetchAllDataAPI(`hr-all-holiday`).then((res) => {
            if (res.data.status === 1) {
                setIsLoading(false);
                setHoliday(...[res.data.holiday]);
            }
            else {
                toast.error("Check you connection!!");
            }
        })
    }
    const handleStatusActive = (holidayid) => {
        activeStatus('hr-active-holiday-status', holidayid).then((res) => {
            if (res.data.status === 1) {
                getHoliday();
            }
        })
    }
    const handleStatusInactive = (holidayid) => {
        activeStatus('hr-inactive-holiday-status', holidayid).then((res) => {
            if (res.data.status === 1) {
                getHoliday();
            }
        })
    }
    const handleRemoveHoliday = (holidayid) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'danger',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        }).then((result) => {
            if (result.isConfirmed) {
                removeDataFromList('hr-remove-holiday', holidayid).then((res) => {
                    if (res.data.status === 1) {
                        Swal.fire(
                            'Deleted!',
                            'Your file has been deleted.',
                            'success'
                        )
                        getHoliday();
                    }
                })
            }
            else if (
                result.dismiss === Swal.DismissReason.cancel
            ) {
                Swal.fire(
                    'Cancelled',
                    'Your imaginary file is safe :)',
                    'error'
                )
            }
        })
    }
    return (
        <div className="holidayPage">
            <Helmet>
                <title>SATKARTAR::HR::HOLIDAY</title>
            </Helmet>
            <ContentWrapper>
                <div className="card employeepage">
                    <h4 className="mb-0 text-uppercase">
                        All Holiday
                        <Link to="/add-holiday" className="btn btn-primary btnemployee"><AiOutlinePlus /> Add Holiday</Link>
                    </h4>
                    <div className="table pagetable table-responsive">
                        <Table className="table-sm table-fixeds" responsive striped bordered hover>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Date</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <>
                                        {[...Array(5)].map((_, index) => (
                                            <tr key={index}>
                                                {Array.from({ length: 5 }).map((_, index) => (
                                                    <td key={index}><Skeleton animation="wave" variant="text" /></td>
                                                ))}
                                            </tr>
                                        ))}
                                    </>
                                ) : records.length > 0 ? (
                                    records?.map((holiday, index) => (
                                        <tr key={holiday?.holiday_id}>
                                            <td>{index + 1}</td>
                                            <td>{holiday?.holiday_name}</td>
                                            <td>{moment(holiday?.holiday_date).format('dddd Do MMMM YYYY')}</td>
                                            <td>
                                                {(() => {
                                                    if (holiday?.holiday_status === "Active") {
                                                        return (
                                                            <span className="badge bg-success btnstatus" onClick={() => handleStatusActive(holiday?.holiday_id)}>Active</span>
                                                        )
                                                    }
                                                    else {
                                                        return (
                                                            <span className="badge bg-danger btnstatus" onClick={() => handleStatusInactive(holiday?.holiday_id)}>Inactive</span>
                                                        )
                                                    }
                                                })()}
                                            </td>
                                            <td>
                                                <div className="d-flex" style={{ gap: "5px" }}>
                                                    <Link to={`/edit-holiday/${holiday?.holiday_id}`} className="btnEdit"><AiFillEdit /></Link>
                                                    <button className="btnDelete" onClick={() => handleRemoveHoliday(holiday?.holiday_id)}><VscTrash /></button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td className="text-center" colSpan={8}>Data not found...</td>
                                    </tr>
                                )}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </tfoot>
                        </Table>
                        <nav className="pagination-container">
                            <ul className="pagination align-items-center">
                                <li className="total-orders ml-2">Total: {holiday.length}</li>
                            </ul>
                            <ul className="pagination">
                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <button className="page-link" onClick={perPage} disabled={currentPage === 1}>
                                        Previous
                                    </button>
                                </li>
                                {numbers.map((n) => {
                                    if (
                                        n === 1 ||
                                        n === npage ||
                                        Math.abs(currentPage - n) <= 2
                                    ) {
                                        return (
                                            <li key={n} className={`page-item ${currentPage === n ? 'active' : ''}`}>
                                                <button className="page-link" onClick={() => changePage(n)}>
                                                    {n}
                                                </button>
                                            </li>
                                        );
                                    } else if (
                                        (n === currentPage - 3 && n > 1) ||
                                        (n === currentPage + 3 && n < npage)
                                    ) {
                                        return (
                                            <li key={n} className="page-item">
                                                <span className="page-link">...</span>
                                            </li>
                                        );
                                    }
                                    return null;
                                })}
                                <li className={`page-item ${currentPage === npage ? 'disabled' : ''}`}>
                                    <button className="page-link" onClick={nextPage} disabled={currentPage === npage}>
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </ContentWrapper>
        </div>
    )
    function perPage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }
    function changePage(id) {
        setCurrentPage(id)
    }
    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }
}

export default Holiday